export class UseOfContextWithoutProviderError extends Error {
  constructor(ContextName: string) {
    super(`use${ContextName} must be used within a ${ContextName}Provider`);
  }
}
